import React from "react";

import Button from "../atoms/button";

import Image from "../molecules/image";

import "../../scss/molecules/_image-button.scss";

import { navigate } from "gatsby-plugin-intl";

const helpers = require("../../helpers");

class ImageButton extends React.Component {
  render() {
    let href = helpers.getTrailedUrl(this.props.to ? this.props.to : "");

    return (
      <div
        className={
          "image-button" +
          (this.props.negateTop ? " image-button-with-negate-top" : "")
        }
        onClick={() => {
          navigate(href);
        }}
      >
        <Button to={href} type="secondary">
          {this.props.title}
        </Button>
        <Image
          fluid={this.props.fluid}
          src={this.props.src}
          alt={this.props.alt}
          overlay="gradient"
        />
      </div>
    );
  }
}

export default ImageButton;
